export enum AssistanceType {
    DIAGNOSTIC = "FDIAG",
    TECHNICAL = "FASSIST"
}
